import { IconProps } from '.';

function CoopIcon({ style, className }: IconProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 16 17"
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      style={style}
    >
      <title>CoopIcon</title>
      <path fillRule="evenodd" clipRule="evenodd" d="M0 8.28467C0 3.87367 3.588 0.284668 8 0.284668C12.411 0.284668 16 3.87367 16 8.28467C16 11.6437 13.916 14.5207 10.975 15.7047C10.947 15.7177 10.919 15.7267 10.889 15.7357C9.992 16.0847 9.019 16.2847 8 16.2847C6.978 16.2847 6.003 16.0837 5.104 15.7337C5.078 15.7257 5.052 15.7177 5.028 15.7057C2.085 14.5227 0 11.6447 0 8.28467ZM11.25 12.6317V14.4787C13.476 13.3047 15 10.9707 15 8.28467C15 4.42467 11.859 1.28467 8 1.28467C4.14 1.28467 1 4.42467 1 8.28467C1 10.9707 2.523 13.3047 4.749 14.4787V12.6317H3.302C3.15 12.6317 3.007 12.5637 2.912 12.4457C2.817 12.3277 2.781 12.1727 2.813 12.0257L4.761 3.11367C4.811 2.88367 5.014 2.71967 5.249 2.71967C5.484 2.71967 5.688 2.88367 5.737 3.11367L7.684 12.0257C7.717 12.1727 7.68 12.3277 7.585 12.4457C7.49 12.5637 7.347 12.6317 7.196 12.6317H5.749V14.9067C6.457 15.1477 7.211 15.2847 8 15.2847C8.788 15.2847 9.542 15.1477 10.25 14.9067V12.6317H8.803C8.652 12.6317 8.509 12.5637 8.414 12.4457C8.319 12.3277 8.282 12.1727 8.315 12.0257L10.262 3.11367C10.312 2.88367 10.515 2.71967 10.75 2.71967C10.985 2.71967 11.188 2.88367 11.238 3.11367L13.186 12.0257C13.218 12.1727 13.182 12.3277 13.087 12.4457C12.992 12.5637 12.849 12.6317 12.697 12.6317H11.25ZM10.75 5.56267L9.424 11.6317H12.076L10.75 5.56267ZM3.92383 11.6317L5.24983 5.56274L6.57583 11.6317H3.92383Z" fill="currentColor" />
    </svg>
  );
}

export default CoopIcon;
